import { useState, useEffect, useContext } from "react";
import EmailVerificationIcon from "../atoms/images/EmailVerificationIcon";
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuid } from "uuid";
import {
  formattedPhone,
  getConsentInfo,
  getCountryCode,
} from "../../helpers/utils";
import { useToast } from "../../hooks/useToast";
import { AuthContext } from "../../context/authContext";
import SendAgainFlow from "../molecules/sendAgain/SendAgainFlow";
import ActionLinkButton from "../atoms/buttons/ActionLinkButton";
import { useTranslation } from "react-i18next";
import Content from "../templates/wrapper/Content";
import Text from "../molecules/content/Text";

const EmailVerification = () => {
  const navigate = useNavigate();
  const location = useLocation();
  let countryCode = getCountryCode();
  const { showToast } = useToast();
  const authContext = useContext(AuthContext);
  const kvkkConsent = getConsentInfo("kvkk");
  const loyaltyConsent = getConsentInfo("loyalty");
  const { t } = useTranslation();

  const [formData, setFormData] = useState(
    () => location.state?.formData || {}
  );

  useEffect(() => {
    if (location.state?.formData) {
      navigate(location.pathname, { replace: true, state: {} });
    }
    if (!formData || Object.keys(formData).length === 0) {
      navigate("/", { replace: true });
    }
  }, [location.state, navigate, location.pathname, formData]);

  const handleTryDiffEmail = () => {
    navigate("/sign-up", {
      state: { formData },
    });
  };

  const handleResend = async () => {
    const data = {
      ...formData,
      // Yeniden gönderim yeni kayıt olarak yapılır (PreSignUp aynı e-postalı UNCONFIRMED kullanıcıyı siler), bu yüzden yeni username gerekir
      username: uuid(),
      phone_number: formattedPhone(formData.phone_number, countryCode),
      country: countryCode,
      content_type: kvkkConsent.typeID.toString(),
      version: kvkkConsent.version,
      content_type_loyalty:
        countryCode == "TR" ? loyaltyConsent.typeID.toString() : "",
      version_loyalty: countryCode == "TR" ? loyaltyConsent.version : "",
      registration_method: "normal_flow",
    };
    try {
      await authContext.signUpWithEmail(data);
      showToast("success", t("accountVerification.successMessage"));
    } catch (err) {
      if (err instanceof Error) {
        showToast("error", err.message);
      }
    }
  };

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <Content isConfirmedPage showRemoveOnDesktop onClose={handleClose}>
      <div className="flex flex-col justify-between items-center h-full">
        <div className="flex flex-col justify-center items-center gap-5">
          <Text variant={"h3"} className="text-vestelColor text-center">
            {t("signUp.verifyEmailAddress")}
          </Text>
          <EmailVerificationIcon size={56} />
          <div className="w-full text-center">
            <Text> {t("signUp.weSentLinkTo")}</Text>{" "}
            <Text variant="bold">{formData.email || ""}</Text>{" "}
            <Text>{t("signUp.toVerifyEmail")} </Text>
          </div>
          <div className="flex flex-col items-center text-center gap-2 mt-6">
            <Text className={"text-[#757575]"}>
              {t("signUp.receiveTheVerificationEmail")};
            </Text>
            <Text className={"text-[#757575]"}>
              * {t("signUp.confirmMailAddress")}
            </Text>
            <Text className={"text-[#757575]"}>
              * {t("signUp.checkSpamJunkMessageFolder")}
            </Text>
          </div>
        </div>
        <div className="flex flex-col items-center gap-8 mt-40">
          <SendAgainFlow
            resendFunction={handleResend}
            label={t("signUp.sendAgainLink")}
          />
          <ActionLinkButton
            handleClick={handleTryDiffEmail}
            text={t("signUp.differentEmailVerify")}
          />
        </div>
      </div>
    </Content>
  );
};

export default EmailVerification;
